export default __webpack_public_path__ + "static/media/tier-2-img.0f20cfe9.svg";